<style lang="scss">

    .app-player{
        padding-top: 0px !important;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0;
        z-index: 1030!important;
        box-shadow: 0 -1px 19px rgba(0, 0, 0, 0.18);
    }
    .skip-previous, .skip-next, .play-icon-wrapper {
        cursor: pointer;
    }
    .player-wrapper {

        .player {
            position: relative;
            width: 100%;
            height: 60px;
            padding: 10px 0px 10px 0px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .myCanvas {
                position: absolute;
                top: 4px;
                z-index: -10;
                left: 200px;
                -webkit-box-reflect: right -100%;
            }
            .mirror-visualizer {
                background: rgba(0, 0, 0, 0) -moz-element(#myCanvas) no-repeat;
                transform: scaleX(-1);
                position: absolute;
                top: 4px;
                z-index: -10;
                left: 200px;
            }
            .hidden-canvas{
                max-width: 1px !important;
                display: block;
            }
            .buy-button {
                padding: 3px 8px;
            }
            .buy-button-mobile {
                display: none;
            }
            .time-indicator-mobile {
                display: none;
            }
            .player-buttons {
                width: 180px;
                .btn-playpause {
                    background: #fff;
                    color: #ff5b94;
                    position: absolute !important;
                    top: 3px !important;
                    left: 3px !important;
                    padding: 0 0px !important;
                    font-size: 16px;
                }

                .player-actions{
                    cursor: pointer;
                }

                .quarter {
                    width: 23px;
                    height: 23px;
                    background-color: #ffffff;
                    opacity: 0.52;
                }

                .top-right {
                    border-top-right-radius: 24px;
                    border-bottom-right-radius: 3px;
                    border-top-left-radius: 3px;
                    position: absolute;
                    right: 0;
                    top: 0;
                }

                .bottom-left {
                    border-bottom-left-radius: 40px;
                    position: absolute;
                    border-top-left-radius: 3px;
                    border-bottom-right-radius: 3px;
                    bottom: 0;
                    left: 0;
                }

                #circle-container {
                    width: 46px;
                    height: 46px;
                    position:relative;
                    z-index:1;
                }

                .backward-button, .forward-button {
                    padding: 4px;
                }
            }
            .player-left-section {
                flex: 1;
                display: flex;
                align-items: center;
                min-width: 33.333%;
            }
            .player-right-section {
                flex: 1;
                min-width: 33.333%;
                z-index: 300;
                position: relative;
                .share-button{
                    margin: 5px 5px 5px 10px;
                }
                .time-indicator-container{
                    text-align: center;
                    padding: 5px;
                    position: absolute;
                    right: 150px;
                    min-width: 100px;
                }
            }

            .beat-details {
                height: 40px;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 13px;
                position: relative;
                top: 6px;
                margin-left: 10px;
                text-overflow: ellipsis;
                .beat-genre{
                    font-size: 10px;
                    text-align: left;
                }
            }
            .player-buttons {
                display: flex;
                align-items: center;
                justify-content: space-around;
                text-align: center;
                margin: auto;
                .play-icon-wrapper {
                    padding: 10px 12px;
                    border-radius: 50%;
                    svg {
                        position: relative;
                        left: 1px;
                    }
                }
                .play-prev, .play-next {
                    font-size: 16px;
                    cursor: pointer;
                }
                .play, .pause {
                    font-size: 13px;
                    cursor: pointer;
                    border-radius: 50%;
                    border: 1px solid #fff;
                }
                .play {
                    padding: 12px 13px 12px 15px;
                }
                .pause {
                    padding: 12px 13px;
                }

                .btn-link:hover {
                    color: unset !important;
                    text-decoration: unset !important;
                    background-color: unset !important;
                    box-shadow: unset !important;
                }

                .btn-icon{
                    padding : 0px !important;
                    width: 20px !important;

                }
            }
            .playing-artwork {
                width: 60px;
                text-align: center;
                margin-top: 10px;
                img {
                    width: 60px;
                    border-radius: 0px;
                }
            }
            .playing-details {
                flex: 2;
                display: flex;
                overflow: hidden;
                position: relative;
                margin-top: 8px;
                padding: 0 10px 4px 5px;

            }
            .player-right-section {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                .player-menu-button {
                    padding: 5px 7px;
                    cursor: pointer;
                }
                .buy-button {
                    margin-right: 15px;
                }
            }

            .volume-control {
                position: relative;
                cursor: pointer;
                margin: 5px 15px 5px 5px;
                width: 26px;
                padding: 5px;
            }

            .infos-control {
                position: relative;
                cursor: pointer;
                margin: 5px;
                padding: 5px;
                font-size: 18px;
                display: block;

            }
            .price-container {
                position: relative;
                margin: 0 5px;
                padding: 0 5px;
                .price{
                    color: rgb(255, 255, 255);
                    height: 34px;
                    max-width: 111.5px;
                    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
                    border-radius: 5px;
                    background-color: #ff1466;
                    font-weight: 500;
                    margin-top: 0px;
                    padding: 9px;
                    min-width: 65px;
                    &.in-cart {
                        padding: 9px;
                        border: 1px solid;
                    }
                }
            }

            .share-button{
                display: block;
            }

            .volume-button {
                cursor: pointer;
                width: 34px;
                padding: 10px;
            }

            .infos-slider-wrapper {
                position: absolute;
                width: 170px;
                bottom: 30px;
                padding: 15px 10px 15px 10px;
                right: 0px;
                background: #4b434d;
                text-align: left;
                border-radius: 5px;
                z-index: 20;
                .pop-content{
                    font-size: 11px;
                    font-family: Poppins;
                }
            }

            .popup-info{
                    height: 15px;
                    width: 15px;
                    position: absolute;
                    top: -22px;
                    right: 2px;
                    transform: rotate(45deg);
                }
            .volume-slider-wrapper {
                position: absolute;
                width: 22px;
                bottom: 30px;
                padding: 15px 0 11px 3px;
                left: 1px;
                background: #4b434d;
                text-align: center;
                border-radius: 5px;
                z-index: 20;
                .slider {
                    height: 100px;
                    width: 10px;
                    .slider-track {
                        width: 3px;
                        margin-left: -2.5px;
                        border-color: #9523b9;
                        background-color: #9523b9;
                    }
                    .slider-handle {
                        width: 15px;
                        height: 15px;
                        margin-left: -6px;
                        border-color: #9523b9;
                    }
                    .slider-selection {
                        background-image: linear-gradient(to bottom, #373648 0%, #373648 100%);
                    }
                    .slider-track-high{
                        background: #fff;
                    }

                    .slider-handle {
                        width: 11px;
                        height: 11px;
                        margin-left: -4px;
                        border-color: #9523b9;
                        background: #fff;
                    }
                }
            }
            .fade-enter-active, .fade-leave-active {
                transition: opacity .2s;
                -webkit-transition: opacity .2s;
            }
            .fade-enter, .fade-leave-active {
                opacity: 0;
            }
        }
    }
    .player-wrapper.open {
        bottom: 0;
    }
    @media screen and (max-width: 767px) {
        .player-wrapper {
            .player {
                .playing-details {
                    flex: 1;
                }
                .player-right-section {
                    display: flex;
                    margin-top: 5px;
                    .sound-position{
                        display: inline-block;
                        font-size: 10px;
                        min-width: 20px;
                    }
                    .sound-duration{
                        display: inline-block;
                        font-size: 10px;
                        min-width: 20px;
                    }

                    .time-indicator-container{
                        text-align: center;
                        padding: 0;
                        position: initial;
                        min-width: 20px;
                        margin-right: 10px;
                    }

                    .text-muted{
                        font-size: 10px;
                        margin-top: -9px;
                    }
                    .volume-control{
                        top: -5px;
                        float: right;
                    }
                    .infos-control{
                        display: none;
                    }

                    .share-button{
                        display: none;
                    }
                }

            }
        }
    }
    @media screen and (max-width: 500px) {
        .player-wrapper {
            .player {
                .player-right-section  {

                }
            }
        }
    }
    @media screen and (max-width: 500px) {
        .player-wrapper {
            .player {
                height: 70px !important;
                padding: 0px;
                width: 100%;
                .playing-artwork, .loop-button, .random-button {
                    display: none;
                }
                .beat-details {
                    top: 10px;
                    font-size: 9px;
                    .beat-genre{
                         font-size: 8px;
                    }

                }
                .playing-details {
                    font-size: 11px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    margin-top: 10px;
                }
                .player-buttons {
                    width: 100%;
                    display: inline-flex;
                     .play, .pause {
                        font-size: 11px;
                    }
                    .play {
                        padding: 12px 12px 12px 14px;
                    }
                }

                .player-left-section, .player-right-section {
                    max-width: 33.33%;
                    min-width: 1px;
                }
                .player-right-section  {
                    .price-container {
                        display: none;
                    }
                }
            }
        }
    }

</style>

<template>

    <div class="app-player player-wrapper bg-mid-grey open" :style="$playerMainStyle" :class="{'open' : showPlaylistSlider}" @click.stop="playerClicked">
        <progress-bar :current-time="currentTime"></progress-bar>

        <div class="player" ref="player">
            <canvas id="myCanvas" v-show="showVisualization" class="myCanvas" :class="{'hidden-canvas' : !show.canvas}" ref="canvas"></canvas>

            <div class="mirror-visualizer" :style="mirroredVisualizer" v-show="showVisualization" :class="{'hidden-canvas' : !show.canvas}"></div>

            <audio crossorigin="anonymous" id="mp-player" ref="audioPlayer"></audio>

            <div class="player-left-section">
                <template v-if="currentlyPlaying">
                    <div class="playing-artwork">
                        <img :src="currentlyPlaying.image(50)" class="beat-image">
                    </div>
                    <div class="beat-details">
                        <span class="beat-name">{{currentlyPlaying.name}}</span>
                        <p v-if="currentlyPlaying.genre" class="beat-genre" :style="$playerSecondaryTextStyle">{{currentlyPlaying.genre.name}}</p>
                    </div>
                </template>
            </div>

            <div class="playing-details">

                <div class="player-buttons">
                    <!--<i class="skip-previous material-icons md-24">skip_previous</i>-->
                    <button class="loop-button btn btn-link btn-icon" @click="setloop()" :style="[loop ? $playerActiveIconsStyle : $playerPrimaryTextStyle]" >
                        <font-awesome-icon :icon="['fas','repeat']"  class="player-actions"></font-awesome-icon>
                    </button>
                    <div class="backward-button" @click="playPrev"><font-awesome-icon icon="backward" class="player-actions"></font-awesome-icon></div>

                    <div id="circle-container">
                        <div class="quarter top-right" :style="$playerPlayButtonStyle"></div>
                        <div class="quarter bottom-left" :style="$playerPlayButtonStyle"></div>
                        <button v-if="isPlaying == true" class="btn-playpause" :style="$playerPlayButtonStyle"  @click.stop="playlistManager.pause(currentTime)">
                            <font-awesome-icon icon="pause"></font-awesome-icon>
                        </button>

                        <button v-else class="btn-playpause" :style="$playerPlayButtonStyle" @click="play()">
                            <font-awesome-icon icon="play"></font-awesome-icon>
                        </button>
                    </div>
                    <div class="forward-button" @click="playNext"><font-awesome-icon icon="forward"class="player-actions"></font-awesome-icon></div>
                    <button class="random-button btn btn-link btn-icon" @click="setrandom()" :style="[random ? $playerActiveIconsStyle : $playerPrimaryTextStyle]" >
                        <font-awesome-icon :icon="['fas','random']" class="player-actions" ></font-awesome-icon>
                    </button>
                </div>

            </div>

            <div class="player-right-section" :style="$playerSecondaryTextStyle">

                <template v-if="currentlyPlaying">
                    <div class="time-indicator-container">
                        <span class="sound-position text-muted">{{Position}}</span>
                        <span v-if="currentlyPlaying.duration" class="sound-duration text-muted"> / {{currentlyPlaying.duration}}</span>
                    </div>
                </template>

                <div v-show="!hideBuyButton" class="price-container" v-if="currentlyPlaying">
                  <buy-button :item="currentlyPlaying.isSoundkitSample ? currentlyPlaying.soundkit : currentlyPlaying"></buy-button>
                </div>


                <div v-if="desktopViewport && currentlyPlaying" class="volume-control" :style="[show.volume ? $playerActiveIconsStyle : '']">
                    <font-awesome-icon v-if="volume > 50" icon="volume-up" @click.stop="toggleVolumeControl"></font-awesome-icon>
                    <font-awesome-icon v-if="volume < 51 && volume > 0" icon="volume-down" @click.stop="toggleVolumeControl"></font-awesome-icon>
                    <font-awesome-icon v-if="volume == 0" icon="volume-off" @click.stop="toggleVolumeControl"></font-awesome-icon>
                    <transition name="fade">
                        <div v-show="show.volume" class="volume-slider-wrapper" :style="$gradientBackground">
                            <bootstrap-slider name="volume-slider" :min="0" :max="100" :value="volume" :step="10" orientation="vertical" :reversed="true" :tooltip="false" :change-event="changeVolume"></bootstrap-slider>
                        </div>
                    </transition>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import hammerjs from "hammerjs"
    import mediaelement from "mediaelement/standalone"
    import hls from "hls.js"
    import ProgressBar from './playerprogressbar.vue'
    import BootstrapSlider from './bootstrapslider.vue'
    import Configure from './../mixins/configure'
    import ShareButton from './sharebutton.vue'
    import BuyButton from './shared/buy-button.vue'

    export default {
        mounted() {
            this.setUpAudio()
            this.volume = this.playlistManager.volume * 100

            this.setUpResponsesToBodyClick()
            this.myCanvasParent = this.$refs.player

            // Check this.createVisualizerForConfigureState as want to connect if configure state to allow changes in configuration
            if(this.showVisualization || this.createVisualizerForConfigureState){
                window.addEventListener('resize', this.handleResize)

                this.createVisualizerCanvas()
            }

        },
        beforeDestroy: function () {
            window.removeEventListener('resize', this.handleResize)
        },
        components: {
            ProgressBar, BootstrapSlider ,ShareButton, BuyButton
        },
        data() {
            return {
                show: {
                    playlist: false,
                    volume: false,
                    canvas: false,
                    infos : false
                },
                volume: 90,
                seeking: false,
                currentTime: null,
                Position: "0:00",
                myAudioPlayer: null,
                animationId : null,
                meterGap:3,
                meterWidth : 3, //width of the meters in the spectrum
                gap : 1, //gap between meters
                meterNum : 150, //count of the meters (by default 150),
                myCanvas: null,
                myCanvasParent: null,
                mirroredVisualizer: {},
                audioSrc: null,
                myCtx: null,
                isPaused : false,

            }
        },
        computed: {
            hideBuyButton() {
                const pages = ab.config.pagesConfig
                const pagePlaylistId = this.playlistManager?.pagePlaylist?.id;
                const beattapesPages = pages
                    .filter(element => element.type === "beattapes")
                    .map(element => element.id);
                return !!(beattapesPages.length && pagePlaylistId && beattapesPages.includes(pagePlaylistId))
            },
            desktopViewport() {
                return this.$store.state.viewPortWidth >= 768
            },
            playlistManager() {
                return this.$store.state.playlistManager
            },
            loop() {
                return this.$store.state.player.loop
            },
            random() {
                return this.$store.state.player.random
            },
            audioManager() {
                return this.playlistManager.audioManager
            },
            currentlyPlaying() {
                return this.playlistManager.getCurrentlyPlaying()
            },
            showMenu() {
                return this.$store.state.player.show.menu
            },
            showPlaylistSlider() {
                return this.$store.state.player.show.playlistSlider
            },
            signedIn() {
                return this.$store.getters.signedIn
            },
            isPlaying() {
                return this.$store.state.player.playing
            },
            mobile() {
				return this.$store.state.mobile
			},
            styleConfig() {
			    return this.$store.state.currentConfig.stylesConfig
            },
            playButtonStyle() {
			    if (this.styleConfig && this.styleConfig.player.play_button_background != undefined && this.styleConfig.player.play_button_icon != undefined) {
			        return {
			            background: this.styleConfig.player.play_button_background.value,
                        color: this.styleConfig.player.play_button_icon.value
                    }
                }
            },
            buyButtonLink() {
                if (!this.currentlyPlaying) {
                    return
                }

                if (this.currentlyPlaying.getType() == "soundkit") {
                    return {name: 'soundkit', params: {'soundkit': this.currentlyPlaying.id}}
                } else {
                    return {name: 'beat', params: {'beat': this.currentlyPlaying.alias}}
                }
            },
            showVisualization() {
                return this.$store.state.currentConfig.showVisualization && this.desktopViewport && !this.isSafari()
            },
            createVisualizerForConfigureState() {
                return this.$store.state.configure && !this.isSafari()
            },
            inCart() {
                return this.$store.state.cart.inCart(this.currentlyPlaying);
            }

        },
        mixins: [Configure],
        watch: {
            '$store.state.player.playing'(val) {
                if (val == true) {
                    this.play()

                    if (this.showVisualization) {
                        // Add delay to take into account if play is pressed in quick succession to pause
                        setTimeout(function () {
                            this.show.canvas = true;
                            this.drawSpectrum()
                        }.bind(this) , 400)
                    }

                } else {

                    if(this.showVisualization){
                        setTimeout(function () {
                            if (!this.$store.state.playing) {
                                this.show.canvas = false
                            }
                        }.bind(this) , 400)
                    }

                }
            },
            '$store.state.currentConfig.showVisualization'(val) {
                if (val) {
                    this.createVisualizerCanvas()
                    if (this.showVisualization) {
                        if (this.isPlaying) this.show.canvas = true
                        this.drawSpectrum()
                    }
                }
            }
        },
        methods: {
            createVisualizerCanvas() {
                if(!this.myCanvas){
                    this.myCanvas = this.$refs.canvas
                    this.myCtx = this.myCanvas.getContext('2d')
                }

                if (this.myCanvasParent) {
                    this.myCanvas.width = this.myCanvasParent.getBoundingClientRect().width - 400
                    this.myCanvas.height = this.myCanvasParent.getBoundingClientRect().height - 5
                    // add 30 because no music hit the top frequencies / and avoid empty space on the visualization
                    this.meterNum = Math.round(this.myCanvas.width / this.meterWidth) + 30

                    this.mirroredVisualizer.width = this.myCanvas.width + 'px'
                    this.mirroredVisualizer.height = this.myCanvas.height + 'px'
                }

            },
            handleResize (event) {
                // Check window.innerWidth rather than use computed prop this.showVisualization as delay in update causes problems with drawing visualizer
                if(this.$store.state.currentConfig.showVisualization && window.innerWidth >= 768){
                    this.createVisualizerCanvas()
                    this.drawSpectrum()
                }
            },
            play () {
                // not sure : this may generate some issue when browsing between pages
                if (!this.playlistManager.getCurrentPlaylist()) {
                    this.playlistManager.setPagePlaylistToCurrent()
                }
                this.playlistManager.resume()

                if(! this.isPaused) {
                    this.myAudioPlayer = document.getElementById('mp-player').getElementsByTagName('audio')[0]

                    // Check this.createVisualizerForConfigureState as want to connect if configure state to allow visualizer to be switched to show in configuration after being hidden
                    if ((this.showVisualization || this.createVisualizerForConfigureState) && this.myCanvas) {
                        this.playlistManager.setAudioAnalyser()
                        this.audioSrc = this.playlistManager.audioCtx.createMediaElementSource(this.myAudioPlayer)
                        this.audioSrc.connect(this.playlistManager.audioAnalyser)
                        this.playlistManager.audioAnalyser.connect(this.playlistManager.audioCtx.destination)
                    }
                }
                this.isPaused = true;
            },
            playNext() {
                this.playlistManager.playNext()
            },
            playPrev() {
                this.playlistManager.playPrev()
            },
            setloop() {
                this.$store.commit("playerLoop", {loop: !this.loop})
            },
            setrandom() {
               this.$store.commit("playerRandom", {random: !this.random})
            },
            toggleVolumeControl() {
                this.show.volume = !this.show.volume
            },
            toggleInfosControl() {
                this.show.infos = !this.show.infos
            },
            changeVolume(value) {
                this.volume = value.newValue
                this.playlistManager.changeVolume(value.newValue / 100)
            },
            playerClicked() {
                this.show.volume = false
                this.show.infos = false
            },
            setUpAudio() {
                let vm = this

                let player = new MediaElement(this.$refs.audioPlayer, {
                    renderers: ['native_hls', 'html5'],
                    success: (media, node) => {
                        media.addEventListener('timeupdate', function() {
                            vm.setSoundPosition()
                        })
                        media.addEventListener('ended', function() {
                            vm.playlistManager.playNext(vm.currentTime)
                        })
                    },
                });

                this.playlistManager.setAudioManager(player)
            },
            setUpResponsesToBodyClick() {
                let vm = this
                document.body.onclick = () => {
                    vm.show.volume = false
                    vm.show.infos = false
                }

                document.body.onkeyup = (e) => {
                    if (e.keyCode === 32 && !($("input").is(':focus') || $("textarea").is(":focus") || $(".ql-editor").is(":focus"))) {
                        if (vm.isPlaying) {
                            vm.playlistManager.pause()
                        } else {
                            vm.play()
                        }
                    }
                }
            },
            setSoundPosition() {
                this.currentTime = this.audioManager.getCurrentTime()

                if (this.currentTime) {
                    let m = Math.floor(this.currentTime % 3600 / 60);
                    let s = Math.floor(this.currentTime % 3600 % 60);
                    s = (s > 9) ? s : "0" + s

                    this.Position = m + "." + s

                } else {
                    this.Position = "0:00"
                }
            },
            pausePlayer(){
                this.playlistManager.pause(this.currentTime)
            },
            drawSpectrum() {
                if (!this.myCanvas) {
                    return
                }
                this.animationId = requestAnimationFrame(this.drawMeter)
            },
            drawMeter() {
                // Check window.innerWidth rather than use computed prop this.showVisualization as delay in update causes problems with drawing visualizer
                if(!this.$store.state.currentConfig.showVisualization || window.innerWidth < 768 || !this.myCanvas || !this.show.canvas) {
                    return
                }

                let array = new Uint8Array(this.playlistManager.audioAnalyser.frequencyBinCount)
                this.playlistManager.audioAnalyser.getByteFrequencyData(array)

                var step = Math.round(array.length/this.meterNum) //sample limited data from the total array
                this.myCtx.clearRect(0, 0, this.myCanvas.width, this.myCanvas.height)

                for (var i = 0; i < this.meterNum; i++) {
                    var value = array[i * step]*this.myCanvas.height/280
                    this.myCtx.fillStyle = this.gr4
                    this.myCtx.fillStyle = this.gradient
                    //set the fillStyle to gradient for a better look
                    let xl3 = i * this.meterGap
                    let margin = Math.floor((this.myCanvas.height - value) / 2 )
                    let yl3 = Math.floor(this.myCanvas.height - margin )
                    let w3 = this.meterWidth
                    let h3 = margin
                    if(value <= 0 ){
                        yl3 = h3 + 1
                    }
                    this.myCtx.lineWidth = this.meterWidth
                    this.myCtx.setLineDash([this.meterWidth, 1]) /*dashes are 5px and spaces are 3px*/
                    this.myCtx.beginPath()
                    this.myCtx.moveTo(xl3, yl3)
                    this.myCtx.lineTo(xl3, h3)
                    this.myCtx.strokeStyle = this.styleConfig.player.visualiser_color.value
                    this.myCtx.stroke()

                    //this.myCtx.fillRect(xl3, yl3 , w3, h3)

                }
                this.animationId = requestAnimationFrame(this.drawMeter)
            },
            isSafari(){
                var ua = navigator.userAgent.toLowerCase()
                if (ua.indexOf('safari') != -1) {
                    if (ua.indexOf('chrome') > -1) {
                        return false
                    } else {
                        return true
                    }
                }
            },
            buyBeat() {
                if (this.currentlyPlaying.getType() !== "beat") {
                    this.currentlyPlaying.addToCart()
                } else {
                    this.$store.commit("buyableBeat", {beat: this.currentlyPlaying})
                    $("#buyLicenseModal").modal("show")
                }
            }
        }
    }
</script>
